import { useEffect, useState } from 'react';
import Seo from '../Seo';
import Page1 from './Page1';
import Page2 from './Page2';
import Page3 from './Page3';

type Props = {};

export default function DzienOjca({}: Props) {
	const [currentPage, setCurrentPage] = useState<number>(1);
	const [componentToDisplay, setComponentToDisplay] =
		useState<React.JSX.Element>();

	function switchPage(component: React.JSX.Element) {
		document.querySelector('.page-holder')?.classList.remove('shown');

		setTimeout(() => {
			document.querySelector('.page-holder')?.classList.add('shown');
			setComponentToDisplay(component);
		}, 500);
	}

	useEffect(() => {
		switch (currentPage) {
			case 1: {
				switchPage(<Page1 />);
				break;
			}
			case 2: {
				switchPage(<Page2 />);
				break;
			}

			case 3: {
				switchPage(<Page3 />);
				break;
			}
		}
	}, [currentPage]);

	return (
		<main className="text-white w-[80%] mx-auto p-8 border-customBlue border-2 rounded-md flex flex-col gap-10 mt-52 mb-20">
			<Seo title="Dzień Ojca" noIndex />
			<div className="page-holder flex flex-col gap-5">
				{componentToDisplay}
			</div>

			<div className="flex w-full justify-between items-center relative mt-auto">
				{currentPage > 1 && (
					<button
						className="pager-button mr-auto"
						onClick={() => setCurrentPage((prev) => prev - 1)}>
						Wstecz
					</button>
				)}
				<span className="absolute left-1/2 translate-x-[-50%] text-xl text-customBlue font-medium">
					{currentPage} / 3
				</span>
				{currentPage < 3 && (
					<button
						className="pager-button ml-auto"
						onClick={() => {
							setCurrentPage((prev) => prev + 1);
						}}>
						Dalej
					</button>
				)}
			</div>
		</main>
	);
}
